import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, setApiGarage } from "@/lib/api";

const AuthCtx = createContext(null);
export const GARAGE_KEY = "gf_active_garage";
export const STAFF_ROLES = ["garage_manager", "mechanic"];

export const staffMemberships = (ms = []) => ms.filter((m) => STAFF_ROLES.includes(m.role) && m.status === "active");
export const customerMemberships = (ms = []) => ms.filter((m) => m.role === "customer");

export function homePathFor(me) {
  if (!me) return "/login";
  if (me.user.is_super_admin) return "/admin";
  if (staffMemberships(me.memberships).length) return "/pro";
  if (me.garage_requests?.length) return "/signup/status";
  const cust = customerMemberships(me.memberships);
  return cust.length === 1 ? `/g/${cust[0].slug}/account` : "/account";
}

export function AuthProvider({ children }) {
  const [me, setMe] = useState(undefined);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setMe(data);
      return data;
    } catch {
      setMe(null);
      return null;
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setMe(data);
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setApiGarage(null);
    localStorage.removeItem(GARAGE_KEY);
    setMe(null);
  };

  return (
    <AuthCtx.Provider value={{ me, user: me?.user, memberships: me?.memberships || [], setMe, refresh, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
